export class MoveToBankRequestDto {
    merchant_id: string
    authorizer: string
    product_id: string
    sourceWallet: string
    card_num: string
    sourceAccountId: string
    volume: string
    value: string
    fees: string
    gross: string
    session_id: string
    bank: string
    currency: string
    product_name: string
    merchant_name: string
}
export class MoveToBankRequestBulkDto {
    merchant_id: string
    authorizer: string
    product_ids: string
    sourceWallet: string
    card_num: string
    sourceAccountId: string
    volume: string
    value: string
    fees: string
    gross: string
    session_id: string
    bank: string
    currency: string
    product_name: string
    merchant_name: string
}

export class MoveToBankDto {
    merchant_id: string
    process_id: string
    product_id: string
    amount: string
}
export class MoveToBankBulkDto {
    merchant_id: string
    process_id: string
    product_ids: string
    amount: string
}


// export class NotifyDto {
//     merchant_id: string
// 	amount: string
// 	description: string
// 	recipient_count: number
// 	tranx_id: string
//     payment_id: string
// }
export class NotifyDto {
    src_wallet: string
    amount: string
    payment_id: string
    merchant_id: string
    description: string
    recipient_count: number
    tranx_id: string
    src_countryCode: string
    recipients: any[]
    payment_type?: string
}